import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "as-goals-scored__head" }
const _hoisted_2 = { class: "as-goals-scored__body" }
const _hoisted_3 = { class: "as-vs" }
const _hoisted_4 = { class: "as-vs__tile" }
const _hoisted_5 = { class: "as-vs__line" }
const _hoisted_6 = { class: "as-vs-line-item" }
const _hoisted_7 = { class: "as-vs-line-item__ball" }
const _hoisted_8 = { class: "as-icon" }
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 0,
  class: "as-vs__text"
}
const _hoisted_12 = { class: "as-bold" }
const _hoisted_13 = { class: "as-green" }
const _hoisted_14 = { class: "as-bold" }
const _hoisted_15 = { class: "as-green" }
const _hoisted_16 = { class: "as-history" }
const _hoisted_17 = { class: "as-history-item" }
const _hoisted_18 = { class: "as-history-item__head" }
const _hoisted_19 = { class: "as-history-item__body" }
const _hoisted_20 = { class: "as-competition" }
const _hoisted_21 = { class: "as-competition__table" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "as-center a" }
const _hoisted_25 = { class: "as-center a" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }

import IconGoalScored from "~src/components/icons/foot_stats/IconGoalScored.vue";
import IBall from "~src/components/icons/incident/IBall.vue";
import FootballTeamItem from "../FootballTeamItem.vue";
import type { IMatch } from "~src/interfaces";
import type {
  IAdditionalInfo,
  IFootyStats,
  ITeam,
  IStatsParent,
} from "~src/interfaces/footystats";
import { computed, ref, onMounted } from "vue";
import { getClassForItem, getImageUrl, getPercentByPoint } from "~src/helpers/footystats";


const __default__ = {};

interface Props {
  match: IMatch;
  mode?: string;
  footyStats: IFootyStats | null;
  homeTeamInfo: ITeam | null;
  awayTeamInfo: ITeam | null;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'GoalsScored',
  props: {
    match: {},
    mode: { default: "as-win" },
    footyStats: {},
    homeTeamInfo: {},
    awayTeamInfo: {}
  },
  setup(__props: any) {

const props = __props;

const activeTab = ref("all");
const setActiveTab = (tab: string) => {
  activeTab.value = tab;
};

const homeTeamLastX = computed<IStatsParent>(() => {
  return props.footyStats?.home_team_last_x ?? ({} as IStatsParent);
});

const awayTeamLastX = computed<IStatsParent>(() => {
  return props.footyStats?.away_team_last_x ?? ({} as IStatsParent);
});

const homePoint = computed<number>(() => {
  if (props.mode === "as-win") {
    return homeTeamLastX.value?.stats?.seasonScoredAVG_overall ?? 0;
  }

  return homeTeamLastX.value?.stats?.seasonConcededAVG_overall ?? 0;
});

const awayPoint = computed<number>(() => {
  if (props.mode === "as-win") {
    return awayTeamLastX.value?.stats?.seasonScoredAVG_overall ?? 0;
  }

  return awayTeamLastX.value?.stats?.seasonConcededAVG_overall ?? 0;
});

const allData = computed<any>(() => {
  let home05 =
    homeTeamLastX.value?.stats?.additional_info
      ?.seasonScoredOver05Percentage_overall ?? 0;
  let away05 =
    awayTeamLastX.value?.stats?.additional_info
      ?.seasonScoredOver05Percentage_overall ?? 0;
  let home15 =
    homeTeamLastX.value?.stats?.additional_info
      ?.seasonScoredOver15Percentage_overall ?? 0;
  let away15 =
    awayTeamLastX.value?.stats?.additional_info
      ?.seasonScoredOver15Percentage_overall ?? 0;
  let home25 =
    homeTeamLastX.value?.stats?.additional_info
      ?.seasonScoredOver25Percentage_overall ?? 0;
  let away25 =
    awayTeamLastX.value?.stats?.additional_info
      ?.seasonScoredOver25Percentage_overall ?? 0;
  let home35 =
    homeTeamLastX.value?.stats?.additional_info
      ?.seasonScoredOver35Percentage_overall ?? 0;
  let away35 =
    awayTeamLastX.value?.stats?.additional_info
      ?.seasonScoredOver35Percentage_overall ?? 0;
  // let homeFailed = homeTeamLastX.value?.stats?.seasonFTSPercentage_overall ?? 0;
  // let awayFailed = awayTeamLastX.value?.stats?.seasonFTSPercentage_overall ?? 0;

  if (props.mode !== "as-win") {
    home05 =
      homeTeamLastX.value?.stats?.additional_info
        ?.seasonConcededOver05Percentage_overall ?? 0;
    away05 =
      awayTeamLastX.value?.stats?.additional_info
        ?.seasonConcededOver05Percentage_overall ?? 0;
    home15 =
      homeTeamLastX.value?.stats?.additional_info
        ?.seasonConcededOver15Percentage_overall ?? 0;
    away15 =
      awayTeamLastX.value?.stats?.additional_info
        ?.seasonConcededOver15Percentage_overall ?? 0;
    home25 =
      homeTeamLastX.value?.stats?.additional_info
        ?.seasonConcededOver25Percentage_overall ?? 0;
    away25 =
      awayTeamLastX.value?.stats?.additional_info
        ?.seasonConcededOver25Percentage_overall ?? 0;
    home35 =
      homeTeamLastX.value?.stats?.additional_info
        ?.seasonConcededOver35Percentage_overall ?? 0;
    away35 =
      awayTeamLastX.value?.stats?.additional_info
        ?.seasonConcededOver35Percentage_overall ?? 0;
    // homeFailed = homeTeamLastX.value?.stats?.seasonFTSPercentage_overall ?? 0;
    // awayFailed = awayTeamLastX.value?.stats?.seasonFTSPercentage_overall ?? 0;
  }

  return [
    {
      title: "Trên 0.5",
      appendTxt: "%",
      home: home05,
      away: away05,
    },
    {
      title: "Trên 1.5",
      appendTxt: "%",
      home: home15,
      away: away15,
    },
    {
      title: "Trên 2.5",
      appendTxt: "%",
      home: home25,
      away: away25,
    },
    {
      title: "Trên 3.5",
      appendTxt: "%",
      home: home35,
      away: away35,
    },
    // {
    //     title: 'Ghi bàn thất bại',
    //     appendTxt: '%',
    //     home: homeFailed,
    //     away: awayFailed
    // },
  ];
});

const firstHalfData = computed<any>(() => {
  // const home1h = 0;
  // const away1h =  0;
  // const home1h = 0;
  // const away1h = 0;
  let homeBothHalves =
    homeTeamLastX.value?.stats?.scoredBothHalvesPercentage_overall ?? 0;
  let awayBothHalves =
    awayTeamLastX.value?.stats?.scoredBothHalvesPercentage_overall ?? 0;
  let homeAverage1H = homeTeamLastX.value?.stats?.scoredAVGHT_overall ?? 0;
  let awayAverage1H = awayTeamLastX.value?.stats?.scoredAVGHT_overall ?? 0;
  let homeAverage2H = homeTeamLastX.value?.stats?.scored_2hg_avg_overall ?? 0;
  let awayAverage2H = awayTeamLastX.value?.stats?.scored_2hg_avg_overall ?? 0;

  if (props.mode !== "as-win") {
    homeAverage1H = homeTeamLastX.value?.stats?.concededAVGHT_overall ?? 0;
    awayAverage1H = awayTeamLastX.value?.stats?.concededAVGHT_overall ?? 0;
    homeAverage2H = homeTeamLastX.value?.stats?.conceded_2hg_avg_overall ?? 0;
    awayAverage2H = awayTeamLastX.value?.stats?.conceded_2hg_avg_overall ?? 0;
  }

  const data = [
    // {
    //     title: props.mode == 'as-win' ? 'Ghi bàn trong H1' : 'Giữ sạch lưới H1',
    //     appendTxt: '%',
    //     home: home1h,
    //     away: away1h
    // },
    // {
    //     title: props.mode == 'as-win' ? 'Ghi bàn trong H2' : 'Giữ sạch lưới H2',
    //     appendTxt: '%',
    //     home: home1h,
    //     away: away1h
    // },
  ];

  if (props.mode === "as-win") {
    data.push({
      title: "Ghi bàn trong cả hai hiệp",
      appendTxt: "%",
      home: homeBothHalves,
      away: awayBothHalves,
    });
  }

  data.push({
    title:
      props.mode == "as-win"
        ? "Điểm trung bình H1"
        : "Trung bình thủng lưới H1",
    appendTxt: "",
    home: homeAverage1H,
    away: awayAverage1H,
  });
  data.push({
    title:
      props.mode == "as-win"
        ? "Điểm trung bình H2"
        : "Trung bình thủng lưới H2",
    appendTxt: "",
    home: homeAverage2H,
    away: awayAverage2H,
  });

  return data;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`as-goals-scored ${_ctx.mode}`)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(IconGoalScored, {
        fill: _ctx.mode === 'as-win' ? '#00FF4B' : '#FF6D6D'
      }, null, 8, ["fill"]),
      _createElementVNode("span", null, _toDisplayString(_ctx.mode == "as-win" ? "Bàn thắng được ghi" : "Bàn thua"), 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(FootballTeamItem, {
        footyStats: _ctx.footyStats,
        match: _ctx.match,
        modifyClass: "as-vertical",
        showName: false,
        showResult: false,
        homePoint: homePoint.value,
        awayPoint: awayPoint.value
      }, null, 8, ["footyStats", "match", "homePoint", "awayPoint"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.mode == "as-win" ? "Ghi được mỗi trận" : "Để thủng lưới mỗi trận"), 1),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "as-vs-line-item__main" }, null, -1)),
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "as-vs-line-item__win" }, null, -1)),
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "as-vs-line-item__draw" }, null, -1)),
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "as-vs-line-item__loss" }, null, -1)),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                (
                    homeTeamLastX.value.stats.seasonScoredAVG_overall >
                    awayTeamLastX.value.stats.seasonScoredAVG_overall
                  )
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _unref(getImageUrl)(_ctx.footyStats?.away_image)
                    }, null, 8, _hoisted_9))
                  : (
                    homeTeamLastX.value.stats.seasonScoredAVG_overall <
                    awayTeamLastX.value.stats.seasonScoredAVG_overall
                  )
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: _unref(getImageUrl)(_ctx.footyStats?.away_image)
                      }, null, 8, _hoisted_10))
                    : (_openBlock(), _createBlock(IBall, { key: 2 }))
              ])
            ])
          ])
        ]),
        (homePoint.value > 0 || awayPoint.value > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              (_ctx.mode === 'as-win')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("span", _hoisted_12, _toDisplayString(homePoint.value > awayPoint.value ? _ctx.footyStats?.home_name : _ctx.footyStats?.away_name), 1),
                    _cache[6] || (_cache[6] = _createTextVNode(" có ")),
                    _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(getPercentByPoint)(homePoint.value, awayPoint.value)) + "%", 1),
                    _cache[7] || (_cache[7] = _createTextVNode(" tốt hơn xét về")),
                    _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
                    _cache[9] || (_cache[9] = _createElementVNode("span", { class: "as-bold" }, "Bàn thắng ghi được", -1))
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("span", _hoisted_14, _toDisplayString(homePoint.value < awayPoint.value ? _ctx.footyStats?.home_name : _ctx.footyStats?.away_name), 1),
                    _cache[10] || (_cache[10] = _createTextVNode(" có ")),
                    _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(getPercentByPoint)(homePoint.value, awayPoint.value)) + "%", 1),
                    _cache[11] || (_cache[11] = _createTextVNode(" tốt hơn xét về")),
                    _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
                    _cache[13] || (_cache[13] = _createElementVNode("span", { class: "as-bold" }, "Bàn thua", -1))
                  ], 64))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(FootballTeamItem, {
        footyStats: _ctx.footyStats,
        match: _ctx.match,
        modeTeam: "as-away",
        modifyClass: "as-vertical",
        showName: false,
        showResult: false,
        status: "as-W",
        homePoint: homePoint.value,
        awayPoint: awayPoint.value
      }, null, 8, ["footyStats", "match", "homePoint", "awayPoint"])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", {
            class: _normalizeClass(["as-head-tab", { 'as-active': activeTab.value === 'all' }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (setActiveTab('all')))
          }, " Cả trận ", 2),
          _createElementVNode("div", {
            class: _normalizeClass(["as-head-tab", { 'as-active': activeTab.value === 'half' }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (setActiveTab('half')))
          }, " Hiệp 1/2 ", 2)
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("table", _hoisted_21, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  (_ctx.mode === 'as-win')
                    ? (_openBlock(), _createElementBlock("th", _hoisted_22, _toDisplayString(activeTab.value === "all" ? "Đã ghi bàn" : "Scored 1st/2nd Half"), 1))
                    : (_openBlock(), _createElementBlock("th", _hoisted_23, _toDisplayString(activeTab.value === "all"
                        ? "Bị thủng lưới"
                        : "Conceded 1st/2nd Half"), 1)),
                  _createElementVNode("th", _hoisted_24, _toDisplayString(_ctx.footyStats?.home_name), 1),
                  _createElementVNode("th", _hoisted_25, _toDisplayString(_ctx.footyStats?.away_name), 1)
                ])
              ]),
              (activeTab.value === 'all')
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_26, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allData.value, (item, key) => {
                      return (_openBlock(), _createElementBlock("tr", { key: key }, [
                        _createElementVNode("td", null, _toDisplayString(item.title), 1),
                        _createElementVNode("td", {
                          class: _normalizeClass(`as-center ${_unref(getClassForItem)(item.home)}`)
                        }, _toDisplayString(item.home) + _toDisplayString(item.appendTxt), 3),
                        _createElementVNode("td", {
                          class: _normalizeClass(`as-center ${_unref(getClassForItem)(item.away)}`)
                        }, _toDisplayString(item.away) + _toDisplayString(item.appendTxt), 3)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (activeTab.value === 'half')
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_27, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(firstHalfData.value, (item, key) => {
                      return (_openBlock(), _createElementBlock("tr", { key: key }, [
                        _createElementVNode("td", null, _toDisplayString(item.title), 1),
                        _createElementVNode("td", {
                          class: _normalizeClass(`as-center ${_unref(getClassForItem)(item.home)}`)
                        }, _toDisplayString(item.home) + _toDisplayString(item.appendTxt), 3),
                        _createElementVNode("td", {
                          class: _normalizeClass(`as-center ${_unref(getClassForItem)(item.away)}`)
                        }, _toDisplayString(item.away) + _toDisplayString(item.appendTxt), 3)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ], 2))
}
}

})